module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Loading', {
    attrs: {
      "show": !_vm.loaded
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "2em"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.freesearch),
      expression: "freesearch"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Sök"
    },
    domProps: {
      "value": (_vm.freesearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.freesearch = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_vm._v("\n          \n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show_winter),
      expression: "show_winter"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.show_winter) ? _vm._i(_vm.show_winter, null) > -1 : (_vm.show_winter)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.show_winter,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.show_winter = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.show_winter = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show_winter = $$c
        }
      }
    }
  }), _vm._v(" Vinter\n          \n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show_summer),
      expression: "show_summer"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.show_summer) ? _vm._i(_vm.show_summer, null) > -1 : (_vm.show_summer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.show_summer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.show_summer = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.show_summer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show_summer = $$c
        }
      }
    }
  }), _vm._v(" Sommar\n      ")])]), _vm._v(" "), _vm._l((_vm.settings), function(s, i) {
    return _c('div', {
      class: 'setting-group'
    }, [_c('div', {
      staticClass: "setting-group-title",
      on: {
        "click": function($event) {
          s.expanded = !s.expanded
        }
      }
    }, [_vm._v(_vm._s(_vm.getTitle(i)) + " "), (!s.expanded) ? _c('span', {
      staticClass: "title-helper"
    }, [_vm._v(_vm._s(_vm.getHelp(s)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      class: (s.expanded ? 'setting-list--expanded' : 'setting-list')
    }, _vm._l((s.entries), function(group) {
      return _c('div', {
        class: 'setting-group-inner'
      }, [_c('div', {
        staticClass: "inner-title"
      }, [_vm._v(_vm._s(group.title))]), _vm._v(" "), _vm._l((group.entries), function(setting) {
        return (_vm.showSetting(setting)) ? _c('div', {
          staticClass: "single-setting-wrapper"
        }, [_c('Setting', {
          attrs: {
            "setting": setting
          }
        })], 1) : _vm._e()
      })], 2)
    }), 0)])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c2094a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Settings.vue
// module id = 880
// module chunks = 0